import { render, staticRenderFns } from "./ShipmentDeliveryNoteDocumentPopUp.vue?vue&type=template&id=510ceb12&scoped=true&"
import script from "./ShipmentDeliveryNoteDocumentPopUp.vue?vue&type=script&lang=js&"
export * from "./ShipmentDeliveryNoteDocumentPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentDeliveryNoteDocumentPopUp.vue?vue&type=style&index=0&id=510ceb12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ceb12",
  null
  
)

export default component.exports